module.exports = __webpack_public_path__ + "static/the-workshop-of-matt-montini-b9a3898331db15a97e75443ad0403884.png";